import Grid2 from "@mui/material/Unstable_Grid2";
import { Link } from "react-router-dom";
import {Engineering, FeedOutlined, MenuBookOutlined} from "@mui/icons-material";
import {Box, Divider, Typography } from "@mui/material";
import { httpClient } from "../utils/http/httpClient";
import { useEffect, useState } from "react";
import { EltrpPage } from "../layout/wrappers/eltrp-page";
import { EltrpBody } from "../layout/wrappers/eltrp-body";
import { EltrpText } from "../layout/wrappers/eltrp-text";
import { SearchBoxLanding } from "../features/landingpage/components/search-box-landing";

export const LandingPage = () => {
  const [imageURL, setImageURL] = useState<string>();

  useEffect(() => {
    httpClient
      .get("/api/v1/data/worldmap", {
        responseType: "blob",
        authenticated: true,
      })
      .subscribe((res) => {
        setImageURL(URL.createObjectURL(res.data));
      });
  }, []);
  return (
    <EltrpPage metaTitle={"ELTRP"} metaDescription={"Research database for end-of-life tyre rubber"}>
      <div style={{ height: "4px" }}></div>
      <section className="landingPageSearch">
        <SearchBoxLanding />
      </section>
      <section className="landingPageLinks">
        <Box
            display={"flex"}
          gap={{ xs: 0, md: 5 }}
          justifyContent={{ xs: "space-evenly", md: "center" }}
          alignItems="center"
          marginTop="1rem"
          marginBottom="1rem"
        >
          <Box display={"flex"} textAlign={"center"} flexGrow={2} justifyContent={{xs: "center", md:"end"}}>
            <Box display={"flex"} alignItems={{xs:"center",md:"end"}} flexDirection={{xs:"column", md:"row"}}>
                <Typography marginRight={"1rem"} variant={"button"}> RECENTLY ADDED: </Typography>
              <Box marginRight={"1rem"}>
                <Link to={"/recently-added-publications/?from=0&size=10"}>
                  <FeedOutlined
                    color="secondary"
                    fontSize="large"
                    sx={{ stroke: "#ffffff", strokeWidth: 0.5 }}
                  />
                  <br />
                  <Typography variant={"button"}> Publications </Typography>
                </Link>
              </Box>
              <Box marginRight={"1rem"} visibility={{xs: "collapse", md:"visible"}}>
                <Typography variant={"button"}> | </Typography>
              </Box>
              <Box marginRight={"1rem"}>
                <Link to={"/recently-added-projects/?from=0&size=10"}>
                  <Engineering
                      color="secondary"
                      fontSize="large"
                      sx={{ stroke: "#ffffff", strokeWidth: 0.5 }}
                  />
                  <br />
                  <Typography variant={"button"}> Projects </Typography>
                </Link>
              </Box>
            </Box>
          </Box>
          <Divider flexItem orientation={"vertical"} />
          <Box display={"flex"} flexGrow={2} textAlign={"center"} justifyContent={{xs: "center", md:"start"}}>
            <Link to={"/dictionary"}>
              <MenuBookOutlined
                color="secondary"
                fontSize="large"
                sx={{ stroke: "#ffffff", strokeWidth: 0.5 }}
              />{" "}
              <br />
              <Typography variant={"button"}> Dictionary </Typography>{" "}
            </Link>
          </Box>
        </Box>
      </section>
      <Divider flexItem />
      <EltrpBody>
        <Grid2 marginTop={"2rem"}>
          <EltrpText>
            <h2> Welcome to End-of-Life Tyre Research Portal (ELTRP) </h2>
            <p>
              {" "}
              <b>ELTRP</b>, the <b>End-of-Life Tyre Research Portal</b>, brings together articles, reports, and ongoing research projects related to recycled tyre rubber. It is a platform designed to support society by providing access to both completed and ongoing research into recycled tyre rubber. The ELTRP is open to everyone, offering reference material for innovators and businesses, as well as authorities, municipalities, and legislators. The portal also features a glossary explaining terminology and concepts commonly associated with research in this area. Users can share reports, save favourites for quick access, and subscribe to receive updates on the latest findings.
            </p>
            <Grid2 marginTop={"2rem"} textAlign={"center"}>
              <h3>
                {" "}
                Geographical overview of research on recycled tyre rubber{" "}
              </h3>
              <img
                id="imageId"
                alt="world-map"
                src={imageURL}
                width={"100%"}
                style={{ maxWidth: "1000px" }}
              />
            </Grid2>
          </EltrpText>
        </Grid2>
      </EltrpBody>
    </EltrpPage>
  );
};
